
























import { Vue, Component } from 'vue-property-decorator';
import { Route } from 'vue-router';
import AppBase from '../common/base';
import { NavigationMenu, NavigationItem } from '../../dndg/components';

@Component({ components: { NavigationMenu } })
export default class Header extends AppBase {
    get navigation() {
        let menu: NavigationItem[] = [{
            title: 'About',
            route: { name: 'about'}
        },
        {
            title: 'Privacy Policy',
            route: { name: 'privacy-policy' }
        },
        {
            title: 'Logout',
            action: async () => {
                await this.$store.dispatch('signOut');
                this.$router.push({ name: 'signup', params: { lang: this.lang }});
            },
            test: (route: Route, store: any) => store.state.isAuthenticated
        }];
        return menu;
    }
}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/common/header.vue